import { useState } from 'react';
import { Popover } from '@mui/material';
import { Text } from '@cyberpion/cyberpion-ui';
import { makeStyles } from '@material-ui/core/styles';
import { RestApi } from 'common/services/rest-api.service';
import { Common } from 'common/services/common.service';
import { setShouldOpenPopsideCommentsTab } from 'features/GridSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from 'app/store';
import { LoginService } from 'login/services/login.service';
import classNames from 'classnames';
// import Tooltip from '@mui/material/Tooltip';
import './Comments.scss';
import { useHistory } from 'react-router-dom';
import { IconWithComments } from 'common/components/Icons/IconWithComments/iconWithComments';
import { IconAddComment } from 'common/components/Icons/IconAddComment/IconAddComment';
import { IconAddCommentGray } from 'common/components/Icons/IconAddCommentGray/IconAddCommentGray';


const optionsTime: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true
};

const useStyles = makeStyles({
  popoverRoot: {
    marginTop: '10px',
    maxHeight: 400,
    minWidth: 400,
    padding: '20px 0px 14px 20px',
    overflow: 'hidden',
    border: '1px solid #ecedff',
    borderRadius: 6,
    boxShadow:
      '0px 77.291px 61.833px 0px rgba(108, 73, 172, 0.07), 0px 32.29px 25.832px 0px rgba(108, 73, 172, 0.05), 0px 17.264px 13.811px 0px rgba(108, 73, 172, 0.04), 0px 9.678px 7.742px 0px rgba(108, 73, 172, 0.04), 0px 5.14px 4.112px 0px rgba(108, 73, 172, 0.03), 0px 2.139px 1.711px 0px rgba(108, 73, 172, 0.02)',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 6,
      marginRight: 20,
      '& .icon-add': {
        display: 'flex',
        padding: '5px',
        borderRadius: 6,
        border: '1px solid #DADDE0',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.20)',
        '&:hover': {
          backgroundColor: '#e7e7e7',
          cursor: 'pointer'
        },
        '&.disabled': {
          opacity: 0.3,
          backgroundColor: '#f5f5f5 !important',
          cursor: 'not-allowed !important',
          '&:hover': {
            backgroundColor: '#f5f5f5 !important',
            cursor: 'not-allowed !important'
          }
        }
      }
    },
    '& .comments-wrapper': {
      overflowY: 'auto',
      maxHeight: 300,
      marginRight: 2
    },
    '& .comments-content': {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 6
    }
  }
});

export function Comments(props: any) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [commentsList, setCommentsList] = useState<any>(null);
  const [count, setCount] = useState<any>(null);
  const dispatch = useDispatch<any>();
  const history = useHistory();
  const activeTab = history.location.pathname.split('/').pop();
  const { user } = useSelector((state: IReduxState) => state.login);

  const classes = useStyles();
  const isDisabled = LoginService.isViewer(user);

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const url = Common.AddMsspAccountIfNeeded(`remediation/action-items/${activeTab}/${props.row.id}/comments/`);

    RestApi.getData(url).subscribe((response: any) => {
      const userComments = response.results.filter((comment: any) => comment.activity_source === 'USER_COMMENT');
      setCommentsList(userComments);
      setCount(userComments.length);
      setAnchorEl(event.target as HTMLButtonElement);
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddOnClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isDisabled) {
      return;
    }
    event.stopPropagation();
    setAnchorEl(null);
    dispatch(setShouldOpenPopsideCommentsTab({ isOpen: true, id: props.row.id }));
  };

  const open = Boolean(anchorEl);
  return (
    <div className={classNames('Comments', { disabled: isDisabled && !props.row.user_comments_count })}>
      {!!props.row.user_comments_count && (
        <div className="comments-cell" onClick={handleOnClick}>
          <div className="icon">
            <IconWithComments />
          </div>
          <Text textSize={12} textColor="#4A79E7" style={{ marginLeft: 6 }}>
            {props.row.user_comments_count}
          </Text>
        </div>
      )}
      {!props.row.user_comments_count && commentsList === null && (
        <div className="comments-cell" onClick={handleAddOnClick}>
          <div className="icon">
            <IconAddComment />
          </div>
        </div>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        classes={{ paper: classes.popoverRoot }}
        disableScrollLock={true}
      >
        <div>
          {!!commentsList && !!commentsList.length && (
            <div className="title">
              <Text textColor="#25262B" weight={500} textSize={15}>
                {`Comments (${count})`}
              </Text>
              <div className={classNames('icon-add', { disabled: isDisabled })} onClick={handleAddOnClick}>
                <IconAddCommentGray />
              </div>
            </div>
          )}
          <div className="comments-wrapper">
            {!!commentsList &&
              !!commentsList.length &&
              commentsList.map((comment: any) => {
                const y = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(new Date(comment.updated_at));
                const m = new Intl.DateTimeFormat('en', { month: 'short' }).format(new Date(comment.updated_at));
                const d = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(new Date(comment.updated_at));
                return (
                  <div className="comments-content" key={comment.id}>
                    <div className="comments-item-date">
                      <div
                        style={{
                          marginTop: 12,
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <div
                          style={{
                            borderRadius: '50%',
                            backgroundColor: '#6285F4',
                            minWidth: 8,
                            minHeight: 8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {/* {iconUserComment} */}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {/* <Tooltip
                            title={`${comment.activity_user}, ${m} ${d}, ${y} ${new Intl.DateTimeFormat(
                              'en-US',
                              optionsTime
                            ).format(new Date(comment.created_at))}`}
                            placement="bottom-start"
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: '#4D4C53',
                                  color: '#FFFFFF',
                                  padding: '3px 6px',
                                  marginBottom: '0px !important',
                                  '& .MuiTooltip-arrow': {
                                    color: '#4D4C53'
                                  },
                                  border: '1px solid black',
                                  borderRadius: 1,
                                  zIndex: '9999999999 !important'
                                }
                              }
                            }}
                          > */}
                          <div>
                            <Text
                              textColor="#8C909A"
                              textSize={13}
                              style={{
                                marginLeft: 8,
                                width: 340,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >{`${comment.activity_user}, ${m} ${d}, ${y} ${new Intl.DateTimeFormat(
                              'en-US',
                              optionsTime
                            ).format(new Date(comment.created_at))}`}</Text>
                          </div>
                          {/* </Tooltip> */}
                        </div>
                      </div>
                    </div>

                    <Text
                      textSize={14}
                      textColor="#454549"
                      style={{ marginTop: 4, marginLeft: 16, maxWidth: 340, lineHeight: 1.5 }}
                    >
                      {comment.activity}
                    </Text>
                  </div>
                );
              })}
          </div>
        </div>
      </Popover>
    </div>
  );
}
